import React, { useState } from 'react'
import { Button } from '../ui'

const WARNING = 'Your preparation will be locked. You can still fill in notes and agenda during the session.'

export function ReadyFlipButton({ scheduledAt, onReady, transitioning, cancelFirst = false }) {
  const [expanded, setExpanded] = useState(false)
  const disabled = !scheduledAt || transitioning

  const handleConfirm = async () => {
    await onReady?.()
    setExpanded(false)
  }

  return (
    <div style={styles.wrapper}>
      {!expanded ? (
        <>
          <Button
            onClick={() => !disabled && setExpanded(true)}
            disabled={disabled}
            title={!scheduledAt ? 'Set a scheduled date first' : undefined}
          >
            Mark as ready
          </Button>
          {!scheduledAt && (
            <span style={styles.hint}>Set a scheduled date first</span>
          )}
        </>
      ) : (
        <div style={styles.expandedPanel}>
          <div style={styles.actions}>
            {cancelFirst && (
              <Button variant="secondary" onClick={() => setExpanded(false)}>Cancel</Button>
            )}
            <Button onClick={handleConfirm} loading={transitioning} loadingLabel="Saving…">
              Confirm
            </Button>
            {!cancelFirst && (
              <Button variant="secondary" onClick={() => setExpanded(false)}>Cancel</Button>
            )}
          </div>
          <p style={styles.warning}>{WARNING}</p>
        </div>
      )}
    </div>
  )
}

const styles = {
  wrapper: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 'var(--space-1)' },
  hint: { fontSize: 11, color: 'var(--text-secondary)' },
  expandedPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-2)',
    maxWidth: 280,
  },
  warning: {
    margin: 0,
    fontSize: 12,
    lineHeight: 1.4,
    color: 'var(--text-primary)',
  },
  actions: { display: 'flex', gap: 'var(--space-2)', justifyContent: 'flex-end' },
}
